import isServerSide from './isServerSide'

export default !isServerSide() && navigator.userAgent.includes('JustoServer')
